import { useNavigate } from "react-router-dom";
import styles from "./CustomBoxHeader.module.css";
import { GoPencil } from "react-icons/go";

const CustomBoxHeader = ({ title, route, action }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (route) {
      navigate(route);
    } else if (action) {
      action();
    }
  };

  return (
    <div className={styles.header_wrap}>
      <div className={styles.title}>{title}</div>
      {action ?
        <button className={styles.edit_btn} onClick={handleClick}>
          <GoPencil />
          Edit
        </button> : ""}
    </div>
  );
};

export default CustomBoxHeader;
